import { Dialog } from "@radix-ui/themes";
import { useAppSelector } from "../../store";
import { PosPending } from "./pos-pending";
import { PaymentQrScan } from "./payment-qr-scan";
import { memo } from "react";
import { Money } from "../../api/types";

type PaymentModalProps = {
  totalAmount: Money;
  setPolling?: (value: boolean) => void;
};

export const PaymentModal = memo(
  ({ totalAmount, setPolling: onSuccess }: PaymentModalProps) => {
    const open = useAppSelector((state) => state.modals.payment.open);

    return (
      <Dialog.Root open={open}>
        <Dialog.Content style={{ maxWidth: 450, borderRadius: 16 }}>
          <PaymentContent totalAmount={totalAmount} setPolling={onSuccess} />
        </Dialog.Content>
      </Dialog.Root>
    );
  }
);

function PaymentContent({
  totalAmount,
  setPolling: onSuccess,
}: PaymentModalProps) {
  const args = useAppSelector((state) => state.modals.payment.args);

  return args?.type ? (
    <PosPending
      checkoutId={args.checkoutId}
      paymentType={args.type}
      totalAmount={totalAmount}
      setPolling={onSuccess}
      hasError={args.hasError}
      defaultErrorStatus={args.errorStatus}
    />
  ) : (
    <PaymentQrScan />
  );
}
